module.exports = __webpack_public_path__ + "static/media/sign-language.8bbc9c70.svg";